<template>
    <v-dialog :value="!!termos.length" width="500" persistent>
        <v-card>
            <v-card-title class="white--text" :style="{ background: $config.dados.corprimaria }">
                {{ $t_('termos_pendentes') }}
            </v-card-title>
            <v-card-text class="pt-4">
                <p>{{ $t_('msg_aceitar_termos_login') }}</p>
                <v-checkbox v-for="termo in termos" :key="termo.idtermo" v-model="selecionados"
                    :value="termo.idtermo" class="ma-0" hide-details>
                    <template v-slot:label>
                        <div>
                            {{ $t_('aceito_termos_1') }}
                            <a style="text-decoration:underline" @click.stop.prevent="termoAberto = termo">
                                {{ termo.dsctermo }}
                            </a>
                        </div>
                    </template>
                </v-checkbox>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3">
                <v-btn text @click="cancelar()">{{ $t_('voltar') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn :color="$config.dados.corprimaria" elevation="0" style="color: white"
                    :disabled="!todosAceitos || loading" :loading="loading" @click="confirmar()">
                    {{ $t_('aceitar_continuar') }}
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog :value="!!termoAberto" width="600" scrollable @input="termoAberto = null">
            <v-card v-if="termoAberto">
                <v-card-title>{{ termoAberto.dsctermo }}</v-card-title>
                <v-card-text v-html="termoAberto.termo"></v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn :color="$config.dados.corsecundaria" text @click="termoAberto = null">
                        {{ $t_('fechar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalTermosPendentes',
        data() {
            return {
                selecionados: [],
                termoAberto: null,
                loading: false,
            }
        },
        computed: {
            termos() {
                return this.$usuario.termosPendentes || []
            },
            todosAceitos() {
                return this.termos.length > 0 && this.termos.every(t => this.selecionados.includes(t.idtermo))
            },
        },
        watch: {
            termos() {
                this.selecionados = []
            },
        },
        methods: {
            cancelar() {
                this.$usuario.termosPendentes = null
            },
            async confirmar() {
                this.loading = true
                try {
                    await this.$usuario.aceitarTermosPendentes(this.selecionados)
                } finally {
                    this.loading = false
                }
            },
        },
    }
</script>
